export default __webpack_public_path__ + "static/media/flash-sale-banner.1098fa93.png";